import angular from 'angular';
import conflictInterestDeclarations from './conflictInterestDeclarations';

export default angular
  .module('scenes.loanAppSections.scenes.conflictInterestDeclarations', [])
  .component('conflictInterestDeclarations', conflictInterestDeclarations).name;
